/*
 * @Author: Kuiper
 * @Date: 2021-06-24 19:37:19
 */
import { App } from 'vue'

// import { SvgIcon } from '/@/components/svg-icon'

/**
 * 全局注册自定义组件
 * @param app
 */
export function setupCustomComponents(app: App) {
  // TODO
  console.log('setupCustomComponents', app)
  // app.component(SvgIcon.name, SvgIcon)
}
